import React, { useEffect } from 'react';
import { Box, config } from 'folds';
import { Page, PageHero, PageHeroSection } from '../../components/page';
import InfoDocLogo from '../../../../public/icon/CurveLogo.png';

import buildConfig from '../../../../build.config';

export function WelcomePage() {
  useEffect(() => {
    if (buildConfig.enableWidgetMode) {
      // for auto login can reset when logined 
      sessionStorage.removeItem("hasRedirectedToSSO");

      // When into Room Left.
      sessionStorage.removeItem("roomLeftReloaded");
    }
  }, []);

  return (
    <Page>
      <Box
        grow="Yes"
        style={{ padding: config.space.S400, paddingBottom: config.space.S700 }}
        alignItems="Center"
        justifyContent="Center"
      >
        <PageHeroSection>
          <PageHero
            icon={<img width="70" height="70" src={InfoDocLogo} alt="InfoDoc Logo" />}
            title="Welcome to Curve"
            subTitle={<span>InfoDoc Technology Corporation</span>}
          >
            <Box justifyContent="Center">
            {}
            </Box>
          </PageHero>
        </PageHeroSection>
      </Box>
    </Page>
  );
}
